export default __webpack_public_path__ + "static/media/SUSHI.26655881.png";